import { getItem, setItem } from "../../utils/localStorage"
import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { ISelectedDeviceIds } from "@types"
const initialState: ISelectedDeviceIds = { deviceIds: getItem("selectedDevices") || [] }

export const getSelectedIds: any = createSlice({
    name: "selectedDevicesIds",
    initialState,
    reducers: {
        setSelectedDeviceIds: (state, action: PayloadAction<ISelectedDeviceIds>) => {
            setItem("selectedDevices", action.payload.deviceIds)
            state.deviceIds = action.payload.deviceIds
        },
    },
})

export const { setSelectedDeviceIds } = getSelectedIds.actions
export default getSelectedIds.reducer
